import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=7403c303"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"
import style0 from "./Shipment.vue?vue&type=style&index=0&id=7403c303&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports